// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Banner_sectionBanner__aRF9x{
    margin-top: 30px;
    width: 100%;
    border-radius: var(--border-radius-lg);
    display: flex;
    justify-content: center;
}
.Banner_sectionBannerContainer__xbhqh{
  position: relative;
  width: 100%;
  border-radius: var(--border-radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 32px;
  box-sizing: border-box;
  max-width: 2300px;

}
.Banner_backgroundImage__7ibpR{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
    border-radius: var(--border-radius-lg);
}
.Banner_contentContainer__Ulmv5{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;
}
.Banner_textContent__Y6e7F{
    max-width: 1110px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
}
.Banner_textContent__Y6e7F h1 {
    font-size: var(--font-size-4xl);
    font-weight: var(--font-bold);
    text-align: left;
  }
  .Banner_subtitle-container__mE\\+ca{
    width: 635px;
  }
  .Banner_textContent__Y6e7F h4 {
    font-size: var(--font-size-lg);
    font-weight: var(--font-bold);
    margin: 0;
    text-align: left;
    white-space: pre-wrap;
  }
  /* Стили для параграфа */
  .Banner_textContent__Y6e7F p {
    text-align: left;
    font-size: var(--font-size-md);
    max-width: 800px;
    line-height: 1.6;
    margin: 0;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
    white-space: pre-wrap;
  }
  .Banner_textContent__Y6e7F p:last-child{
    margin-top: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/pages/Services/sections/Banner/Banner.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,sCAAsC;IACtC,aAAa;IACb,uBAAuB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;;AAEnB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,sCAAsC;AAC1C;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;IAChB,qBAAqB;EACvB;EACA,wBAAwB;EACxB;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,2CAA2C;IAC3C,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB","sourcesContent":[".sectionBanner{\n    margin-top: 30px;\n    width: 100%;\n    border-radius: var(--border-radius-lg);\n    display: flex;\n    justify-content: center;\n}\n.sectionBannerContainer{\n  position: relative;\n  width: 100%;\n  border-radius: var(--border-radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 100px 32px;\n  box-sizing: border-box;\n  max-width: 2300px;\n\n}\n.backgroundImage{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    z-index: 1;\n    border-radius: var(--border-radius-lg);\n}\n.contentContainer{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n}\n.textContent{\n    max-width: 1110px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: center;\n}\n.textContent h1 {\n    font-size: var(--font-size-4xl);\n    font-weight: var(--font-bold);\n    text-align: left;\n  }\n  .subtitle-container{\n    width: 635px;\n  }\n  .textContent h4 {\n    font-size: var(--font-size-lg);\n    font-weight: var(--font-bold);\n    margin: 0;\n    text-align: left;\n    white-space: pre-wrap;\n  }\n  /* Стили для параграфа */\n  .textContent p {\n    text-align: left;\n    font-size: var(--font-size-md);\n    max-width: 800px;\n    line-height: 1.6;\n    margin: 0;\n    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);\n    white-space: pre-wrap;\n  }\n  .textContent p:last-child{\n    margin-top: 20px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionBanner": `Banner_sectionBanner__aRF9x`,
	"sectionBannerContainer": `Banner_sectionBannerContainer__xbhqh`,
	"backgroundImage": `Banner_backgroundImage__7ibpR`,
	"contentContainer": `Banner_contentContainer__Ulmv5`,
	"textContent": `Banner_textContent__Y6e7F`,
	"subtitle-container": `Banner_subtitle-container__mE+ca`
};
export default ___CSS_LOADER_EXPORT___;
